import { getMaxChartValueAcrossDatasets } from '../../../utils/chart_utils/chart_utils';

import { chartYAxisFormatter } from '../../../utils/formatters';

export const getMaxValueAcrossDatasets = (datasets = [], withPaddedMax = false) => {
  const newMaxY = getMaxChartValueAcrossDatasets(datasets);
  const parsedMaxY = parseFloat(newMaxY.toString());

  if (withPaddedMax) {
    const paddedMaxY = parsedMaxY + (parsedMaxY * 0.2);
    return chartYAxisFormatter.format(paddedMaxY);
  }

  return chartYAxisFormatter.format(parsedMaxY);
}

export default getMaxValueAcrossDatasets;
